export default __webpack_public_path__ + "static/media/billy_safe.45ee6bb2.png";